import { CSSProperties, TableHTMLAttributes } from 'react';
import classNames from 'classnames';

import { isDefined } from '@/utils/is-defined';

import className from './layout-table.module.css';

interface TableProps extends TableHTMLAttributes<HTMLTableElement> {
  borderSpacingVertical?: CSSProperties['borderSpacing'];
  ignoreHeaderRowSpacing?: boolean;
}

const Table = ({ children, style, borderSpacingVertical, ignoreHeaderRowSpacing, ...props }: TableProps) => {
  const hasBorderSpacing = isDefined(borderSpacingVertical);
  const ignoreRowSpacing = hasBorderSpacing && !isDefined(ignoreHeaderRowSpacing) ? true : ignoreHeaderRowSpacing;
  return (
    <table
      {...props}
      style={{
        ...style,
        ...(isDefined(borderSpacingVertical)
          ? { '--layout-table-border-spacing-vertical': borderSpacingVertical }
          : {}),
      }}
      className={classNames(
        className['bl-table'],
        {
          [className['has-border-spacing']]: hasBorderSpacing,
          [className['ignore-header-row-spacing']]: ignoreRowSpacing,
        },
        props?.className || ''
      )}
    >
      {children}
    </table>
  );
};

export default Table;
